// extracted by mini-css-extract-plugin
export default {"ContainerPrincipal":"estilo_ContainerPrincipal__bCjF+","titulo":"estilo_titulo__+XOpl"};